export class DealerOrderTransferVM {
  rowId: number;
  CropYear: number;
  CompanyCode: string;
  ItemId: number;
  ItemNumber: string;
  ItemDescription: string;
  Brand: string;
  MarketingBrand: string;
  PrimaryUom: string;
  SecondaryUom: string;
  Conv: number;
  FromShipToAccount: number;
  ToShipToAccount: number;
  FromPrimaryQty: number;
  FromSecondaryQty: number;
  ToPrimaryQty: number;
  ToSecondaryQty: number;
  FromOrderId: number;
  FromOrderNo: string;
  FromOrderItemId: number;
  RemainingQuantity: number;
  TransferableUnits: number;
  OriginalFromQty: number;
  ModifiableUnit: number;
  LineErrors: any;
  FromChangeType: string;
  ToChangeType: string;
  EmailTo: string;
  DealerModifiableUnits: number;
  SoftCommitUnits: number;
  seedNonReturnable: boolean;
  EAModifiableUnits: number;
  IsItemInInclusion: boolean;
  IsSelected: boolean;
  ProductLine: boolean;
  isRib: boolean;
  isValidForRibTransfer: boolean;
}
